import Sidebar from "../components/SidebarUpdate";
import { useNavigate } from "react-router-dom";
import DummyImage from "../assest/images/dummy_image.jpg";

const Tagfolder = () => {
  const navigate = useNavigate();
  return (
    <div className="parent_Container">
      <div className="content_wrapper sm:p-4 p-2 md:px-8">
        <Sidebar logo="FP ONE" />

        <div className="content_wrapper_child md:ml-[18rem] mt-[5rem] md:mt-0">
          <button onClick={() => navigate(-1)} className="mb-5">
            &larr; Back
          </button>
          <div className="product_detail">
            <div className="card-container flex sm:flex-row flex-col gap-4">
              <div
                className="p-4 w-full sm:w-[400px] h-[200px] bg-slate-200 flex items-center justify-center cursor-pointer"
                onClick={() => navigate("/tag/lace/?view=apparel")}
              >
                <span className="font-semibold text-[25px]">Lace</span>
              </div>

              <div
                className="p-4 w-full sm:w-[400px] h-[200px] flex items-center bg-slate-200 justify-center  cursor-pointer"
                onClick={() => navigate("/tag/pintuck/?view=apparel")}
              >
                <span className="font-semibold text-[25px]">Pintuck</span>
              </div>

              {/* <div className="product_container">
                <div className="cart">
                  <div
                    className="image-wrapper relative"
                    // onClick={() => handleProductClick(product.style_id)}
                  >
                    <img
                      src={DummyImage}
                      alt="Selected Product"
                      className="image"
                    />

                    <div
                      className="p-4 w-full sm:w-[400px] flex items-center justify-center cursor-pointer"
                      onClick={() => navigate("/tag/lace/?view=apparel")}
                    >
                      <span className="font-semibold text-[25px]">Lace</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tagfolder;
